<!-- 模拟交易领涨股 -->
<template>
  <div class="Jylzg" :class="$route.query.themeStyleVs == 2 ? 'black_theme' : 'white_theme'">
    <div class="title_t">
      <p class="name">模拟交易领涨股<van-icon name="question-o" @click="hint" /></p>
      <p @click="seeMore">更多<van-icon name="arrow" /></p>
    </div>
    <ul class="list">
      <li v-for="liIndex in Math.ceil(lzgList.length / 3)" :key="liIndex" class="list_li_w">
        <template v-for="index in 3">
          <!-- 检查是否有数据项，如果没有则显示占位元素 -->
          <template v-if="(liIndex - 1) * 3 + index <= lzgList.length">
            <!-- 已有数据项的处理 -->
            <div
              :key="(liIndex - 1) * 3 + index - 1"
              class="list_li_n"
              @click="gotoDetail(lzgList[(liIndex - 1) * 3 + index - 1].stkCode)"
            >
              <div class="left">
                <p
                  class="index"
                  :style="
                    (liIndex - 1) * 3 + index === 1
                      ? { 'background-image': `url(${require(`@/assets/image/phb1_2x.png`)}` }
                      : (liIndex - 1) * 3 + index === 2
                      ? { 'background-image': `url(${require(`@/assets/image/phb2_2x.png`)}` }
                      : (liIndex - 1) * 3 + index === 3
                      ? { 'background-image': `url(${require(`@/assets/image/phb3_2x.png`)}` }
                      : ''
                  "
                >
                  {{ (liIndex - 1) * 3 + index }}
                </p>
                <div class="info">
                  <p class="name" v-if="!isVip && compareVersions($route.query.version , 9.71)">****</p>

                  <p class="name" v-else>
                    {{
                      lzgList[(liIndex - 1) * 3 + index - 1]
                        ? lzgList[(liIndex - 1) * 3 + index - 1].name
                        : '--'
                    }}
                  </p>
                  <p class="code" v-if="!isVip && compareVersions($route.query.version , 9.71) ">******</p>

                  <p class="code" v-else>
                    {{
                      lzgList[(liIndex - 1) * 3 + index - 1]
                        ? lzgList[(liIndex - 1) * 3 + index - 1].stkCode.slice(2, 9)
                        : '--'
                    }}
                  </p>
                </div>
              </div>

              <div class="right">
                <p class="num">
                  入选{{
                    lzgList[(liIndex - 1) * 3 + index - 1]
                      ? lzgList[(liIndex - 1) * 3 + index - 1].involvedCount
                      : '0'
                  }}个
                </p>
                <p
                  class="percentage"
                  :class="[judgeBgColor(lzgList[(liIndex - 1) * 3 + index - 1].rate)]"
                >
                  {{
                    toFixedNum(
                      lzgList[(liIndex - 1) * 3 + index - 1]
                        ? lzgList[(liIndex - 1) * 3 + index - 1].rate
                        : 0,
                      2,
                      '%'
                    )
                  }}
                </p>
              </div>
            </div>
          </template>
        </template>

        <!-- 检查是否少于 9 条数据且满足特定条件 -->
        <div class="groundGlass" @click="showVIP" v-if="!isVip && compareVersions($route.query.version , 9.71)">
          <div>
            <img src="@/assets/image/homeVIP.png" alt="" />
            <p>解锁查看</p>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { getHotMokpanelLeading } from '@/api/index.js';
import { judgeBgColor, toFixedNum,compareVersions } from '@/utils/format';
import mixin from '@/mixins/index.js';

export default {
  name: 'Jylzg',
  mixins: [mixin],
  props: [],

  data() {
    return {
      lzgList: [],
      interval: null,
      isVip: false
    };
  },
  filters: {},
  created() {},
  watch: {
    '$store.state.isVip': {
      handler(newValue) {
        this.isVip = newValue;
      },
      immediate: true // 立即执行一次
    }
  },
  async mounted() {
    await this.getHotMokpanelLeadingFun();

    this.interval = setInterval(() => {
      this.getHotMokpanelLeadingFun();
    }, 1000 * 60);
  },
  methods: {
    judgeBgColor,
    toFixedNum,
    compareVersions,

    getHotMokpanelLeadingFun: function () {
      var params = {};
      return getHotMokpanelLeading(params)
        .then((res) => {
          if (res.data.length) {
            this.lzgList = res.data.slice(0, 9);
          }
        })
        .catch((err) => {
          this.$toast(err);
        });
    },
    seeMore: function () {
      // 判断是否是 vip
      if(this.isVip == false &&  compareVersions(this.$route.query.version , 9.92) ) {
        let appJson = {
          DialogType: "basic",
        };
        DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc(
          'factorTYPerDialog',
          JSON.stringify(appJson),
          ''
        );
      } else if (this.isVip == false && compareVersions(this.$route.query.version , 9.71)) {
        // 如果不是VIP用户,弹出VIP提示
        let appJson = {
          channel: 'yinzi',
          dzhadid: '0705'
        };
        DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc(
          'factorNoVipPerDialog',
          JSON.stringify(appJson),
          ''
        );
      } else {
        this.$router.push({
          path: '/jylzgMore',
          query: this.$route.query
        });
      }
    },

    hint: function () {
      this.$dialog
        .alert({
          message: '热门模拟交易持仓中涨幅最高的股票'
        })
        .then(() => {
          // on close
        });
    },
    gotoDetail: function (code) {
      // 判断是否是 vip
      if(this.isVip == false && compareVersions(this.$route.query.version , 9.92)) {
        let appJson = {
          DialogType: "basic",
        };
        DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc(
          'factorTYPerDialog',
          JSON.stringify(appJson),
          ''
        );
      } else if (this.isVip == false && compareVersions(this.$route.query.version , 9.71)) {
        // 如果不是VIP用户,弹出VIP提示
        let appJson = {
          channel: 'yinzi',
          dzhadid: '0704'
        };
        DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc(
          'factorNoVipPerDialog',
          JSON.stringify(appJson),
          ''
        );
      } else {
        this.gogufs(code);
      }
    },

    //点击vip遮罩
    showVIP: function () {
      if(this.isVip == false && compareVersions(this.$route.query.version , 9.92) ) {
        let appJson = {
          DialogType: "basic",
        };
        DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc(
          'factorTYPerDialog',
          JSON.stringify(appJson),
          ''
        );
      } else if (this.isVip == false && compareVersions(this.$route.query.version , 9.71) ) {
        // 如果不是VIP用户,弹出VIP提示
        let appJson = {
          channel: 'yinzi',
          dzhadid: '0704'
        };
        DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc(
          'factorNoVipPerDialog',
          JSON.stringify(appJson),
          ''
        );
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.interval);
  }
};
</script>
<style lang="less" scoped>
.Jylzg {
  padding: 0 0 0 16px;
  margin-top: 30px;
  .title_t {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 9px;
    padding-right: 16px;
    .name {
      display: flex;
      align-items: center;
      ::v-deep {
        .van-icon-question-o {
          margin-left: 5px;
          margin-top: 2px;
        }
      }
    }
    p {
      color: #222;
      &:first-child {
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
      }
      &:last-child {
        border-radius: 10px;
        background: #f7f8fa;
        padding: 3px 6px 3px 10px;
        font-size: 10px;
        font-weight: 500;
      }
    }
  }
  .list {
    display: flex;
    width: 100%;
    overflow-x: auto;
    .list_li_w {
      width: 300px;
      border-radius: 8px;
      border: 1px solid #e5e5e5;
      // height: 143px;
      flex-shrink: 0;
      margin-right: 10px;
      padding: 4px 12px;
      line-height: 24px;
      margin-bottom: 2px;
      position: relative;
      .list_li_n {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 5px 0;
        .left {
          display: flex;
          align-items: center;
          .index {
            width: 16px;
            height: 16px;
            flex-shrink: 0;
            color: #fff;
            text-align: center;
            font-size: 12px;
            line-height: 16px;
            border-radius: 4px;
            background: url('../../assets/image/phb4_2x.png') no-repeat;
            background-size: 100% 100%;
          }
          .info {
            margin-left: 8px;
            line-height: normal;
            .name {
              color: #555;
              font-size: 16px;
            }
            .code {
              color: #999;
              font-size: 12px;
            }
          }
        }
        .right {
          display: flex;
          align-items: center;
          .num {
            color: #999;
            font-size: 12px;
            margin-right: 8px;
          }
          .percentage {
            border-radius: 4px;
            background: #999;
            color: #fff;
            font-size: 12px;
            width: 52px;
            height: 22px;
            text-align: center;
            line-height: 22px;
          }
        }
      }
      .groundGlass {
        // background: rgba(255, 255, 255, 0.8);
        backdrop-filter: blur(5px); /* 标准写法 */
        position: absolute;
        z-index: 9;
        top: 0px;
        left: 30px;
        width: 130px;
        height: 100%;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 40px;
          height: 26px;
          margin-left: 4px;
        }
        p {
          color: #a96c35;
          font-size: 12px;
        }
      }
    }
  }
}
</style>

<!-- 黑色主题 -->
<style lang="less" scoped>
.black_theme {
  .title_t {
    p {
      &:first-child {
        color: #e4e9fe;
      }
      &:last-child {
        background: #1d202d;
        color: #e4e9fe;
      }
    }
  }

  .list {
    .list_li_w {
      border: 1px solid #353a50;
      background: #272935;
      .list_li_n {
        .info {
          .name {
            color: #aab9d1 !important;
          }
          .code {
            color: #6b7687 !important;
          }
        }

        .right {
          .num {
            color: #6b7687;
          }
        }
      }
      .groundGlass {
        // background: rgba(39, 41, 53, 0.8);
      }
    }
  }
}
</style>
